import type { CookieConsentTranslations } from "./pl";

export const de: CookieConsentTranslations = {
  ariaLabel: "Cookie-Einwilligung",
  title: "Cookies und Datenschutz",
  defaultText:
    "Wir verwenden Cookies, damit die Website ordnungsgemass funktioniert und - mit Ihrer Einwilligung - fuer Analyse und Marketing. Sie koennen alle akzeptieren, optionale ablehnen oder Ihre Auswahl anpassen.",
  acceptAll: "Alle akzeptieren",
  rejectAll: "Optionale ablehnen",
  customize: "Anpassen",
  settingsTitle: "Cookie-Einstellungen",
  alwaysActive: "Immer aktiv",
  back: "Zurueck",
  savePreferences: "Auswahl speichern",
  cookiesLabel: "Cookies",
  manageButton: "Cookie-Einstellungen",
  close: "Schliessen",
  showCookies: "Cookies anzeigen",
  hideCookies: "Cookies ausblenden",
  cookieHost: "Host",
  cookieDuration: "Dauer",
  cookieDescription: "Beschreibung",
};
